/**
 * Created by nico.lee on 16/11/18.
 */

/* 合法uri*/
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}
/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str)
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str)
}

/* 大小写字母*/
export function validatAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str)
}

/**
 * 验证邮箱
 * @param str
 * @returns {boolean}
 */
export function validatEmail(str) {
  // const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
  // const reg = /\w+@[0-9a-z]+(\.[0-9a-z]{2,6})+/;
  const reg = /^([a-z0-9A-Z]+[-_|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/; // 同后端的验证一样
  return reg.test(str)
}

/**
 * 校验手机号码：必须以1开头的11位数字
 * @param s
 * @returns {boolean}
 */
export function isMobile(s)
{
  var patrn=/^1[3|4|5|6|7|8|9]\d{9}$/;
  if (!patrn.exec(s)) return false;
  return true
}

/**
 * 校验强密码：必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-20之间
 * @param s
 * @returns {boolean}
 */
export function strongPwd(s)
{
  var patrn = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
  if (!patrn.exec(s)) return false;
  return true
}

// passFisrtStrong
export function passFisrtStrong(s)
{
  var patrn = /^[0-9A-Za-z]{8,20}$/;
  if (!patrn.exec(s)) return false;
  return true
}

// passSecondStrong
export function passSecondStrong(s)
{
  var patrn = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{3,20}$/;
  if (!patrn.exec(s)) return false;
  return true
}

export function dealPassFisrtStrong(s)
{
  var patrn = /^[0-9A-Za-z]{6,20}$/;
  if (!patrn.exec(s)) return false;
  return true
}

export function dealPassSecondStrong(s)
{
  var patrn = /^(?=.*\d)(?=.*[A-Za-z]).{3,20}$/;
  if (!patrn.exec(s)) return false;
  return true
}

/**
 * 校验强mt4交易密码：必须包含字母和数字的组合，不能使用特殊字符，长度在8-20之间
 * @param s
 * @returns {boolean}
 */
export function strongMt4DealPwd(s)
{
  var patrn = /^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/;
  if (!patrn.exec(s)) return false;
  return true
}


/**
 * 校验身份证号码：15位或者18位，最后一位为字母X
 * @param s
 * @returns {boolean}
 */
export function isIdno(s)
{
  var patrn = /^\d{15}|\d{18}|\d{17}x|\d{14}x$/;
  if (!patrn.test(s)) return false;
  return true
}



/**
 * 校验护照
 * @param s
 * @returns {boolean}
 */
export function isPassport(s)
{
  var patrn = /^[a-zA-Z0-9]{3,21}$/;
  if (!patrn.test(s)) return false;
  return true
}

/*
* 银行卡验证
* */
export function isBackCard(s) {
  var patrn = /^([1-9]{1})(\d{15,18})$/;
  if (!patrn.test(s)) return false;
  return true
}
export function onlyTwoBitFloat(s) {
  var patrn = /^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/;
  if(!patrn.test(s)) return false;
  return true;
}

export function maxOneFloatOrNone(s) {
  var patrn = /^\d*(\.?\d{0,1})/;
  if(!patrn.test(s)) return false;
  return true;
}

/**
 *验证多少个字符,一个汉字两个字符
 * @param val
 * @returns {number}
 */
export function getByteLen(val) {
  var len = 0;
  for (var i = 0; i < val.length; i++) {
    var a = val.charAt(i);
    if (a.match(/[^\x00-\xff]/ig) != null) {//\x00-\xff→GBK双字节编码范围
      len += 2;
    }
    else {
      len += 1;
    }
  }
  return len;
}

export function limitNumber(inputString) {
  return inputString.replace(/[^((0-9) | \.)]/g, '');
}

export function limitInt(inputString) {
  return inputString.replace(/[^(0-9)]/g, '');
}
//只能输入大小写和数字  用于账号校验
export function limitAccount(inputString) {
  return inputString.replace(/[^A-Za-z0-9]/g, '');
}

export function valiteTwofixAndInt(s) {
  var patrn = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
  if(!patrn.test(s)){return false}
  if(s == 0){return false}
  return true;
}

export function handReg(s) {
  var patrn = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;
  if(!patrn.test(s)){return false}
  if(s == 0){return false}
  return true;
}


export function twoDecimal(s) {
  var patrn = /^[0-9]+\.[0-9]{2}$/;
  if(!patrn.test(s)){return false}
  if(s == 0){return false}
  return true;
}

export function maxTwoFloatOrNone(s) {
  var patrn = /^\d+(?:\.\d{1,2})?$/;
  if(!patrn.test(s)) return false;
  return true;
}


// var ret=/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
export function NOmoreThanTwoDecimal(s) {
  var patrn = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
  if(!patrn.test(s)){return false}
  if(s == 0){return false}
  return true;
}

/*非0正整数*/
export function noZeroInit(s) {
  var patrn = /^[1-9]\d*$/;
  if(!patrn.test(s)){ return false };
  return true;
}

// ^[a-zA-Z0-9_]{3,20}$\

/*字母和数字以及下划线*/
export function noZhcn(s) {
  var patrn = /^[a-zA-Z0-9_]{3,20}$/;
  if(!patrn.test(s)){ return false };
  return true;
}

/*金额输入框输入*/
export function amountInputValidate(val,managedFund){
  let value;
  val = val || '';
  if(managedFund){
    // 管理资金,10的倍数
    if(val.toString().match(/^\d*/g)){
      value = val.toString().match(/^\d*/g)[0];
    }
  }else {
    if(val.toString().match(/^\d*(\.?\d{0,2})/g)){
      value = val.toString().match(/^\d*(\.?\d{0,2})/g)[0];
    }
  }


  let amount = parseFloat(value)
  if (value === '' || value.endsWith('.') || value.endsWith('.0')) {
    amount = value
  }
  return amount;
}


